import { render, staticRenderFns } from "./AddFormRecommendation.vue?vue&type=template&id=6b806032&scoped=true"
import script from "./AddFormRecommendation.vue?vue&type=script&lang=js"
export * from "./AddFormRecommendation.vue?vue&type=script&lang=js"
import style0 from "./AddFormRecommendation.vue?vue&type=style&index=0&id=6b806032&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b806032",
  null
  
)

export default component.exports